import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as base32 from 'hi-base32';
// import QRCode from 'qrcode.react';

import { update2fUserInfo, init2fForUser, get2fSettingsForUser } from '../actions/api';
import { setTwoFactorChannelId, setTwoFactorSettings, setShowConfirmReInit2FPopup, setIs2fEnabledSecond, setShowError, setErrorResponse } from '../actions/localStates';

import i18next from 'i18next'
import ErrorMessagePopup from '../components/ErrorMessagePopup'

class TwoFactorContainerPopup extends Component {

  constructor(props) {
      super(props);
      this.state = {
          twoFactorChannelId : "",
          twoFactorSettings: "",
          imgSrc: null,
          isEmpty: false,
          isLoading: false,
          showVTokenPassWarning: false,
          showPopup: false
      }

      this.onChannelChanged = this.onChannelChanged.bind(this);
      this.handleConfirm = this.handleConfirm.bind(this);

      this.init = this.init.bind(this);
      this.disble2F = this.disble2F.bind(this);

      this.reInit = this.reInit.bind(this);

  }

  componentDidMount() {
    var _this = this;
      this.props.actions.setShowConfirmReInit2FPopup(false)
      this.props.actions.get2fSettingsForUser(this.props.base.authUrl, this.props.login.accessToken)
      .then((response) => {
        _this.setState({twoFactorChannelId: response.authenticatorId})
        if (response.authenticatorSettings.qrCodePngData !== undefined) {
          const qr = response.authenticatorSettings.qrCodePngData.trim();
                _this.setState({
                    imgSrc: qr.startsWith("data:")
                        ? qr
                        : `data:image/png;base64,${qr}`
                });
        }
        
        console.log(response)
      })
      // if (this.props.user.twoFactorChannelId !== null) {
      //     this.setState({twoFactorChannelId: this.props.user.twoFactorChannelId})
      //     // if (this.props.user.twoFactorChannelId === "googleAuthenticator2FChannel") {
      //     //     var src = "otpauth://totp/" + i18next.t("headerTitle") + ":" + this.props.user.userName + "?algorithm%3DSHA1%3Fdigits=6%3Fissuer%3D" + i18next.t("headerTitle") + "&period=30&secret=" + this.props.user.twoFactorSettings.secretKey
      //     //     this.setState({imgSrc: src})
      //     //     console.log(src)
      //     //     console.log(this.props.user.twoFactorSettings.secretKey)
      //     // }
      // } else {
      //     this.setState({twoFactorChannelId: this.props.user.twoFactorAvailabelChannels[0].id})
      // }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.user.twoFactorAvailabelChannels !== prevProps.user.twoFactorAvailabelChannels) {
      this.setState({twoFactorChannelId: this.props.user.twoFactorAvailabelChannels[0].id})
    }
  }

  init () {
    var _this = this;
    var data = {
      "authenticatorId": this.state.twoFactorChannelId || this.props.user.twoFactorAvailabelChannels[0].id,
      "withEnrollment": true
    }

    this.setState({isLoading: true})

    this.props.actions.init2fForUser(this.props.base.authUrl, this.props.login.login, data, this.props.login.accessToken)
    .then((response) => {
        if (response.code !== undefined) {
            this.props.actions.setErrorResponse(response)
            this.setState({showPopup: true})
            // alert(response.message);
            this.setState({isLoading: false})
            // this.props.closeTwoFactorPopup()
            return
        } else {
            this.props.actions.setShowConfirmReInit2FPopup(false)
            if (response.qrCodePngData !== undefined) {
                const qr = response.qrCodePngData.trim();
                this.props.actions.setTwoFactorChannelId(this.state.twoFactorChannelId)
                this.setState({
                    imgSrc: qr.startsWith("data:")
                        ? qr
                        : `data:image/png;base64,${qr}`
                });
            }

            const isEmpty = Object.keys(response).length === 0;

            if (isEmpty) {
              this.props.actions.setTwoFactorChannelId(this.state.twoFactorChannelId)
              _this.setState({imgSrc: null})
              _this.setState({isEmpty: true})
            }

            this.setState({isLoading: false})
            this.props.actions.setIs2fEnabledSecond(!this.props.login.is2fEnabledSecond)

            this.props.actions.get2fSettingsForUser(this.props.base.authUrl, this.props.login.accessToken)
            .then((response) => {
              _this.setState({twoFactorChannelId: response.authenticatorId})

              if (response.authenticatorId === "vtokenPassAuthenticator") {
                _this.setState({showVTokenPassWarning: true})
              }

              if (response.authenticatorSettings.qrCodePngData !== undefined) {
                const qr = response.authenticatorSettings.qrCodePngData.trim();
                      _this.setState({
                          imgSrc: qr.startsWith("data:")
                              ? qr
                              : `data:image/png;base64,${qr}`
                      });
              }
              
              console.log(response)
            })
            // this.props.closeTwoFactorPopup()
        }
    })
  }

  reInit () {
    this.props.actions.setShowConfirmReInit2FPopup(!this.props.base.showConfirmReInit2FPopup)
  }

  disble2F () {
    var data = {
      "authenticatorId": ""
    }

    this.props.actions.init2fForUser(this.props.base.authUrl, this.props.login.login, data, this.props.login.accessToken)
    .then((response) => {
        if (response.code !== undefined) {
            this.props.actions.setErrorResponse(response)
            this.setState({showPopup: true})
            // alert(response.message);
            this.props.closeTwoFactorPopup()
            return
        } else {
            this.setState({imgSrc: null})
            this.setState({isEmpty: false})
            this.setState({twoFactorChannelId: ""})
            this.setState({showVTokenPassWarning: false})
            this.props.actions.setTwoFactorChannelId(null)
            this.props.actions.setIs2fEnabledSecond(!this.props.login.is2fEnabledSecond)
            // this.props.closeTwoFactorPopup()
        }
    })
  }

  handleConfirm () {
      // var secret = {
      //     secretKey: this.state.twoFactorSettings
      // }
      var data = {
            "twoFactorChannelId": this.state.twoFactorChannelId
      }

      // this.props.actions.setTwoFactorSettings(secret)
      this.props.actions.setTwoFactorChannelId(this.state.twoFactorChannelId)
      // console.log(data)
      this.props.actions.update2fUserInfo(this.props.base.serviceUrl, this.props.user.userName, data, this.props.login.accessToken)
      .then((response) => {
          if (response.code !== undefined) {
              alert(response.message);
              this.props.closeTwoFactorPopup()
              return
          } else {
              this.props.closeTwoFactorPopup()
          }
      })
  }

  onChannelChanged (e) {
    this.setState({imgSrc: null})
    this.setState({isEmpty: false})

    function makeid(length) {
        var result           = [];
        var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var charactersLength = characters.length;
        for ( var i = 0; i < length; i++ ) {
          result.push(characters.charAt(Math.floor(Math.random() * charactersLength)));
       }
       return result.join('');
    }

    var secret = {
        secretKey: this.state.twoFactorSettings
    }

    if (e.target.value === "googleAuthenticator2FChannel") {

        var key = base32.encode(makeid(20));
        this.setState({twoFactorSettings: key})
        this.setState({twoFactorChannelId: e.target.value})
        
        // this.setState({imgSrc: "otpauth://totp/" + i18next.t("headerTitle") + ":" + this.props.user.userName + "?algorithm%3DSHA1%3Fdigits=6%3Fissuer%3D" + i18next.t("headerTitle") + "&period=30&secret=" + key})
        console.log(key);
    } else {
        this.setState({twoFactorSettings: secret})
        this.setState({twoFactorChannelId: e.target.value})
    }

    if (e.target.value === "disabled") {
        
        this.setState({twoFactorSettings: secret})
        this.setState({twoFactorChannelId: ""})
    }

    this.setState({showVTokenPassWarning: false})

    console.log(e.target.value)
    
  }

  checkIfAuthenticatorSetted () {
    var currentAuthenticatorTitle = i18next.t("notSetted"), _this = this;

    if (this.props.user.twoFactorAvailabelChannels !== null) {
        this.props.user.twoFactorAvailabelChannels.forEach((chanel) => {
          if (chanel.id === _this.state.twoFactorChannelId) {
            currentAuthenticatorTitle = chanel.title
          }
        })
    }
    
    return currentAuthenticatorTitle;
  }

  checkIfAuthenticatorSettedForOtherActions () {
    var setted = false, _this = this;

    if (this.props.user.twoFactorAvailabelChannels !== null) {
        this.props.user.twoFactorAvailabelChannels.forEach((chanel) => {
          if (chanel.id === _this.state.twoFactorChannelId) {
            setted = true
          }
        })
    }
    
    return setted;
  }

  showMessagePopup () {
    if (this.state.showPopup === true) {
      this.props.actions.setShowError(false)
    }

    if (this.state.showPopup === true && this.state.needToReEnterPin === true) {
      if (this.state.numberOfPinInput > 0) {
        this.props.actions.setNeed2fConfirm(true);
      } else {
        this.props.actions.setGlobalProcessing(false);
        this.setState({needToReEnterPin: false});
        this.setState({numberOfPinInput: 0});
      }
    }

      this.setState({
          showPopup: !this.state.showPopup
      });
  }

  render() {
      return (
          <div className='popup'>
              <div className="popup_inner_2f_for_qr">
                  <div className="col-12">
                      <h4 style={{paddingLeft: "15px", paddingTop: "30px"}}>{i18next.t("titleFor2F")}</h4>
                      {
                        this.state.twoFactorChannelId !== null && this.state.twoFactorChannelId.length > 0
                        ? <div>
                              <label style={{paddingLeft: "15px", color: "rgb(181, 177, 175)", marginBottom: "0px"}}>{i18next.t("currentAuthenticator")}</label>
                              <label style={{paddingLeft: "15px"}}>{this.checkIfAuthenticatorSetted()}</label>
                          </div>
                        : <div>
                            <label style={{paddingLeft: "15px", color: "rgb(181, 177, 175)", marginBottom: "0px", width: "100%"}}>{i18next.t("currentAuthenticator")}</label>
                            <label style={{paddingLeft: "15px"}}>{i18next.t("notSetted")}</label>
                          </div>

                      }
                      <div>
                          <label style={{paddingLeft: "15px", color: "rgb(181, 177, 175)"}}>{i18next.t("availableAuthenticator")}</label>
                          {
                            this.props.user.twoFactorAvailabelChannels === null || this.props.user.twoFactorAvailabelChannels.length === 0
                            ? <label style={{paddingLeft: "15px"}}>notAvailable</label>
                            : <div style={{paddingLeft: "15px", paddingRight: "15px"}}>
                                <select style={{"paddingRight": "0px"}} defaultValue={(this.state.twoFactorChannelId !== null && this.state.twoFactorChannelId.length > 0) ? this.state.twoFactorChannelId : 0} className="form-control" onChange={this.onChannelChanged}>
                                  {
                                    this.props.user.twoFactorAvailabelChannels.map((channel) =>
                                      <option key={channel.id} value={channel.id} className="row" selected={this.props.user.twoFactorChannelId === channel.id ? true : false} style={{marginTop: "5px"}}>{channel.title}</option>)
                                  }
                                </select>
                              </div>
                          }
                      </div>

                      {
                        this.checkIfAuthenticatorSettedForOtherActions() && this.state.imgSrc === null && !this.state.isEmpty && !this.state.isLoading
                        ? <div style={{paddingLeft: "15px", paddingTop: "10px"}}>
                            <input type="checkbox" id="confirm" checked={this.props.base.showConfirmReInit2FPopup ? true : false} onClick={this.reInit} />
                            <label style={{paddingLeft: "28px", marginBottom: "0px", marginTop: "-25px", marginRight: "15px"}} for="confirm">{i18next.t("confirmationMessage")}</label>
                          </div>
                        : null
                      }
                      {/*<div>
                          {
                            this.state.imgSrc
                            ? <div className="col-12">
                                <label style={{marginBottom: "0px", marginTop: "10px"}}>{i18next.t("qrLabel")}</label>
                                <label style={{marginBottom: "0px", fontWeight: "600", wordWrap: "anywhere"}}>{this.state.twoFactorSettings}</label>
                              </div>
                            : null
                          }
                      </div>*/}

                      {
                        this.state.isLoading
                        ? <div className="loading-div-inner-2fa">
                            <i className="fa fa-spinner fa-pulse"></i>
                          </div>
                        : null
                      }
                      <div>
                          {
                            this.state.imgSrc
                            ? <div className="col-12" style={{textAlign: "center", paddingTop: "10px"}}>
                                <img src={this.state.imgSrc} style={{width: "256px", height: "256px"}} alt="img" />
                                
                              </div>
                            : null
                          }
                          {
                            this.state.showVTokenPassWarning
                            ? <div className="col-12" style={{textAlign: "center"}}>
                                {
                                  i18next.t("vTokenPASSActiwaitingWarning")
                                }
                              </div>
                            : null
                          }
                      </div>
                      </div>
                          
                      <div>
                      <div style={{marginLeft: "15px", marginRight: "15px"}}>
                          {
                            this.state.imgSrc !== null
                            ? null
                            : <div className="col-12" style={{ textAlign: "center", paddingTop: "10px" }}>
                                {
                                  this.checkIfAuthenticatorSettedForOtherActions() && this.state.isEmpty
                                  ? null
                                  : 
                                  this.state.isLoading
                                  ? null
                                  : <button
                                      className="btn btn-info"
                                      onClick={this.init}
                                      style={{ width: "100%" }}
                                      disabled={this.props.base.showConfirmReInit2FPopup ? false : this.checkIfAuthenticatorSettedForOtherActions() ? true : false}
                                    >
                                      {this.checkIfAuthenticatorSettedForOtherActions() ? i18next.t("reInit") : i18next.t("init")}
                                    </button>
                                }
                              </div>
                          }
                      </div>
                      {
                        this.state.showPopup
                        ? <ErrorMessagePopup closeMessagePopup={this.showMessagePopup.bind(this)} data={this.props.user.errorResponse} />
                        : null
                      }
                      <div style={{marginLeft: "15px", marginRight: "15px"}}>
                          {
                            this.state.twoFactorChannelId === ""
                            ? null
                            : <div className="col-12" style={{ textAlign: "center", paddingTop: "10px" }}>
                                <button
                                  className="btn btn-info"
                                  onClick={this.disble2F}
                                  style={{ width: "100%" }}
                                  disabled={this.state.isLoading ? true : false}
                                >
                                  {i18next.t("disble2F")}
                                </button>
                              </div>
                          }
                      </div>
                      <div style={{float: "right", marginRight: "30px", paddingTop: "30px"}}>
                          {/*<button className="btn btn-info" style={{marginLeft: "5px", marginBottom: "30px"}} onClick={this.handleConfirm}>{i18next.t("okLabel")}</button>*/}
                          <button className="btn btn-info" disabled={this.state.isLoading ? true : false} style={{marginLeft: "5px", marginBottom: "30px"}} onClick={this.props.closeTwoFactorContainerPopup}>{i18next.t("closeLabel")}</button>
                      </div>
                  </div>
              </div>
          </div>
      );
    }
}

function mapStateToProps(state) {
    return {
        base: state.base,
        selectedClient: state.clientReducer,
        user: state.userReducer,
        login: state.loginReducer
    }
}

const mapDispatchToProps = (dispatch) => {
    const actions = {
      setTwoFactorChannelId,
      setTwoFactorSettings,
      update2fUserInfo,
      init2fForUser, setShowConfirmReInit2FPopup,
      get2fSettingsForUser, setIs2fEnabledSecond,
      setShowError, setErrorResponse
    };
    return {
       actions: bindActionCreators(actions, dispatch)
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(TwoFactorContainerPopup);